import axios from "../axiosSetup";
import qs from "qs";
import { getCsrfToken } from "../csrf";

let statusesCache = null;
let statusesPromise = null;
let customersCache = null;
let customersPromise = null;

export const getOrderStatuses = async () => {
  if (statusesCache) return statusesCache;
  if (statusesPromise) return statusesPromise;

  statusesPromise = axios
    .get("/order/dropdown/order-status")
    .then((res) => {
      statusesCache = Array.isArray(res.data) ? res.data : [];
      return statusesCache;
    })
    .finally(() => {
      statusesPromise = null;
    });

  return statusesPromise;
};

export const getOrderCustomers = async () => {
  if (customersCache) return customersCache;
  if (customersPromise) return customersPromise;

  customersPromise = axios
    .get("/order/dropdown/customers")
    .then((res) => {
      customersCache = Array.isArray(res.data) ? res.data : [];
      return customersCache;
    })
    .finally(() => {
      customersPromise = null;
    });

  return customersPromise;
};

export const listOrders = async (params) => {
  const res = await axios.get("/order", { 
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
  return res.data;
};

export const deleteOrderById = async (orderId) => {
  await axios.delete(`/order/${orderId}`);
};

export const getOrderById = async (orderId) => {
  const res = await axios.get(`/order/${orderId}`);
  return res.data;
};

export const updateOrderStatus = async (orderId, payload) => {
  const res = await axios.patch(`/order/status/${orderId}`, payload);
  return res.data;
};
export const cancelOrderById = async (orderId) => {
  const res = await axios.delete(`/order/cancel/${orderId}`);
  return res.data;
};

export const cloneOrder=async (orderId)=>{
  const res=await axios.get(`/order/clone/${orderId}`);
  return res.data;
}

export const getMyCustomer = async () => {
  const res = await axios.get("/customer");
  return res.data || {};
};

export const getWarehouses = async (customerId) => {
  const res = await axios.get("/dropdown/warehouses", { params: { customerId: String(customerId) } });
  return Array.isArray(res.data) ? res.data : [];
};

export const getProductCodes = async (customerId) => {
  const res = await axios.get("/dropdown/product-code", { params: { customerId: String(customerId) } });
  return Array.isArray(res.data) ? res.data : [];
};

export const getProductPricing = async (productCode, customerId) => {
  const res = await axios.get("/dropdown/product-prices-and-customer-discount", {
    params: { productCode: String(productCode).trim(), customerId, isOrder: true },
  });
  let data = res.data;
  if (Array.isArray(data)) data = data[0];
  else if (data?.data) data = data.data;
  return data || {};
};

export const addOrderAdditionalFile = async (orderId, file) => {
  const formData = new FormData();
  formData.append("additionalFiles", file);
  const res = await axios.put(`/order/add-file/${orderId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const removeOrderAdditionalFile = async (orderId, fileName) => {
  const res = await axios.put(`/order/remove-file/${orderId}`, undefined, {
    params: { fileName },
  });
  return res.data;
};

export const parsePurchaseOrder = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch("/api/parser", {
    method: "POST",
    body: formData,
    credentials: "include",
    headers: { "X-CSRF-Token": getCsrfToken() || "" },
  });

  if (!response.ok) {
    let errorPayload = null;
    try {
      errorPayload = await response.json();
    } catch {
      try {
        errorPayload = await response.text();
      } catch {
        errorPayload = null;
      }
    }
    const err = new Error(`Failed to parse purchase order (status ${response.status})`);
    err.response = { status: response.status, statusText: response.statusText, data: errorPayload };
    throw err;
  }

  const res = await response.json();
  return res && typeof res === "object" && !Array.isArray(res) && res.data && typeof res.data === "object"
    ? res.data
    : res;
};

export const saveCustomerOrder = async (payload, { orderId, purchaseOrderFile, additionalFiles, isSave = false } = {}) => {
  const formData = new FormData();
  if (purchaseOrderFile) {
    formData.append("purchaseOrder", purchaseOrderFile);
  }
  (additionalFiles || []).forEach((file) => {
    formData.append("additionalFiles", file);
  });
  formData.append("order", JSON.stringify(payload));

  let url = orderId ? `/order/${orderId}` : "/order";
  if (isSave) {
    url += "?isSave=true";
  }

  const res = await axios[orderId ? "put" : "post"](url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getOrderFile = async (orderId, fileName, isPOFile = false) => {
  const res = await axios.get(`/order/file/${orderId}`, {
    params: { fileName, isPOFile },
    responseType: "blob",
  });
  return res;
};